module.exports = __webpack_public_path__ + "static/media/ContasPagRec3.c8c194f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagens/RelContasPagRec/ContasPagRec3.png
// module id = 2012
// module chunks = 0